// motion.js — scroll reveal + count-up. Plain JS, no React needed.
// Adapted from the original standalone HTML to be triggered as a hook.

export function initMotion() {
  // ── Scroll reveal via IntersectionObserver ──
  const init = () => {
    const els = document.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(el => io.observe(el));
  };

  // ── Count-up for stat values ──
  const countUp = (el) => {
    const raw = el.getAttribute('data-count') || el.textContent.trim();
    const m = raw.match(/^([^\d]*)([\d,]+(?:\.\d+)?)([^\d]*)$/);
    if (!m) return;
    const prefix = m[1] || '';
    const target = parseFloat(m[2].replace(/,/g, ''));
    const suffix = m[3] || '';
    const dur = 1400;
    const start = performance.now();
    const fmt = (n) => {
      if (target >= 1000) return Math.round(n).toLocaleString();
      if (target % 1 !== 0) return n.toFixed(0);
      return Math.round(n).toString();
    };
    const tick = (now) => {
      const t = Math.min(1, (now - start) / dur);
      const e = 1 - Math.pow(1 - t, 3);
      el.textContent = prefix + fmt(target * e) + suffix;
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = prefix + (raw.includes(',') ? target.toLocaleString() : m[2]) + suffix;
    };
    requestAnimationFrame(tick);
  };

  const initCount = () => {
    const els = document.querySelectorAll('[data-countup]:not(.counted)');
    if (!('IntersectionObserver' in window)) { els.forEach(countUp); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('counted');
          countUp(en.target);
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(el => io.observe(el));
  };

  // Run after react paints; a couple of attempts since react may render late
  let attempts = 0;
  const timers = [];
  const run = () => {
    init();
    initCount();
    attempts++;
    if (attempts < 8) timers.push(setTimeout(run, 250));
  };
  run();

  return () => timers.forEach(clearTimeout);
}
